export const claimTypeFeatureKey = 'claimType';

export type ClaimTypeModel = {
  id: number;
  name: string;
  productCategoryId: number;
  productCategoryName?: string;
  sequence: number;
  active: boolean;
  /** Default claim fee (frais de sinistre) pre-filled on a claim of this type. */
  defaultFeeAmount?: number;
  claimTypeDocumentTypes?: ClaimTypeDocumentTypeModel[];
};

export type ClaimTypeDocumentTypeModel = {
  id: number;
  claimTypeId: number;
  claimTypeName: string;
  documentTypeId: number;
  documentTypeName: string;
  mandatory: boolean;
};
